import type { TagsManager } from 'dxf-writer'
import DatabaseObject from 'dxf-writer/src/DatabaseObject.js'
import type Handle from 'dxf-writer/src/Handle.js'

interface IComplexElement {
  length: number
  tags?: (manager: TagsManager) => void
}

type IElement = IComplexElement | number

/**
 * DXF 线型（LTYPE）表记录，支持简单线型与含嵌入字符的复杂线型。
 */
export default class LineType extends DatabaseObject {
  /** 记录句柄，组码 5 */
  declare handle: Handle
  /** 所有者对象句柄，组码 330 */
  declare ownerObjectHandle: Handle
  /** 子类标记链，用于组码 100 */
  declare subclassMarkers: string[]

  constructor(
    public name: string,
    public description: string,
    public elements: IElement[]
  ) {
    super(['AcDbSymbolTableRecord', 'AcDbLinetypeTableRecord'])
    this.name = name
    this.description = description
    this.elements = elements
  }

  /**
   * 写入 LTYPE 组码序列。
   *
   * @param manager - DXF 标签写入器
   */
  tags(manager) {
    manager.push(0, 'LTYPE')
    super.tags(manager)
    manager.push(2, this.name)
    manager.push(3, this.description)
    manager.push(70, 0)
    manager.push(72, 65)
    manager.push(73, this.elements.length)
    manager.push(40, this.getElementsSum())

    this.elements.forEach((element) => {
      const isNumber = typeof element === 'number'
      manager.push(49, isNumber ? 1 : element.length)
      if (isNumber) {
        manager.push(74, 0)
      } else {
        element.tags?.(manager)
      }
    })
  }

  /**
   * 计算线型元素长度绝对值之和。
   *
   * @returns 各元素长度绝对值求和，用于组码 40 总模式长度
   */
  getElementsSum() {
    return this.elements.reduce((sum: number, element: IElement) => {
      return sum + Math.abs(typeof element === 'number' ? 1 : element.length)
    }, 0)
  }
}
